import { render, staticRenderFns } from "./KpiTargetEdit.vue?vue&type=template&id=5622b05d&"
import script from "./KpiTargetEdit.vue?vue&type=script&lang=js&"
export * from "./KpiTargetEdit.vue?vue&type=script&lang=js&"
import style0 from "./KpiTargetEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports